import React, { PureComponent } from 'react';
import { compose, mapProps, withProps } from 'recompose';
import { withStoreDetail } from '../Providers/WithStoreDetail';
import config from '../../../config';

class SupportEmail extends PureComponent {
  render() {
    const {
      supportEmail,
    } = this.props;
    return (
      <a href={`mailto:${supportEmail}`}>
        {supportEmail}
      </a>
    );
  }
}

export const getStoreCode = ({ ...otherProps, store: { code = '' } = {} }) => ({
  code: code.substring(2).toLowerCase(),
  ...otherProps,
});

export const withExtractSupportEmail = compose(withProps(({ code }) => ({
  supportEmail: `support-${code}@photobookworldwide.com`,
})));

export const withSupportEmail = compose(
  withStoreDetail,
  mapProps(getStoreCode),
  withExtractSupportEmail,
);

export const supportEmailString = () => {
  const supportEmail = `support-${config.storeCode.substring(2).toLowerCase()}@photobookworldwide.com`;
  return `<a href="mailto:${supportEmail}">${supportEmail}</a>`;
};

const enhance = compose(
  withSupportEmail,
);

export default enhance(SupportEmail);
export const undecorated = SupportEmail;



// WEBPACK FOOTER //
// ./src/Common/Helpers/SupportEmail.js